<template>
  <p class="mb-0">{{ status }}</p>
</template>

<script>
  export default {
    name: 'WsTest',

    data() {
      return {
        status: 'Hazırlanıyor ...',
      };
    }, // end data

    props: ['userId'],

    mounted() {
      setTimeout(() => {
        this.status = 'Bekleniyor ...';

        const channel = 'user.' + this.userId;
        console.log('WsTest', 'channel', channel);

        Echo.private(channel)
          .listen('.test', (e) => {
            this.status = '2/3 ...';

            $.get('/api/v1/websocket', (resp) => {
              console.log('/api/v1/websocket', resp);
              if (resp === 'OK') {
                this.status = '3/3 Başarılı!';
                return;
              }
              this.status = '2/3 Failed';
            });
          });

        setTimeout(() => {
          this.status = '1/3 ...';
          $.post('/test/websocket', (resp) => {
            console.log('WsTest', '/test/websocket response', resp);
          }, 'json');
        }, 2000);

      }, 50);
    }, // end mounted
  }
</script>
